define(['formCommon/mixins/formMixin'], function (formMixin) {
    'use strict';
    return {
        formMixin
    };
});
